import SellerApp from "apps/seller/SellerApp";
import ExternalApp from "apps/external/ExternalApp";
import { APP_TYPES, getAppType } from "utils/appConfig";

function App() {
  const appType = getAppType();

  if (appType === APP_TYPES.EXTERNAL) {
    return <ExternalApp />;
  }

  return <SellerApp />;
}

export default App;
